import { callWrapper } from 'api/utils';
import axios from 'axios';

const path = '/api/jsr';

const jsr = {
    uploadFile: callWrapper((data) =>
        axios.post(`${path}/upload-files`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    ),
    allFiles: callWrapper(() => axios.get(`${path}/files`)),
    processFile: callWrapper((data) =>
        axios.post(`${path}/process-file`, data)
    ),
    deleteFile: callWrapper((id) => axios.delete(`${path}/file/${id}`)),
};
export default jsr;
